// src/toolkitServices/customerApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const customerApi = createApi({
  reducerPath: "customerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["Customer"],
  endpoints: (builder) => ({
    // ----------------- CRUD Customers -----------------
    addCustomer: builder.mutation({
      query: (data) => ({
        url: "/customers",
        method: "POST",
        body: data, // 👈 isme branchId / tenantId jo bhi bhejoge, backend handle karega
      }),
      invalidatesTags: ["Customer"],
    }),

    getAllCustomers: builder.query({
      query: ({
        page = 1,
        limit = 1000,
        search = "",
        active,
        city,
        state,
        gst,
        pan,
        contact,
        sortBy,
        sortOrder,
        branchId,   // 👈 NEW
        tenantId,   // 👈 NEW (optional, if backend uses)
      } = {}) => {
        const params = { page, limit };

        if (search) params.q = search;
        if (typeof active === "boolean") params.isActive = active;
        if (city) params.city = city;
        if (state) params.state = state;
        if (gst) params.gst = gst;
        if (pan) params.pan = pan;
        if (contact) params.contact = contact;
        if (sortBy) params.sortBy = sortBy;
        if (sortOrder) params.sortOrder = sortOrder;

        // 🔹 Branch-wise + tenant-wise filter
        if (branchId) params.branchId = branchId;
        if (tenantId) params.tenantId = tenantId;

        return { url: "/customers", params };
      },
      providesTags: ["Customer"],
    }),

    getCustomerById: builder.query({
      query: (id) => `/customers/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Customer", id }],
    }),

    updateCustomer: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/customers/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Customer"],
    }),

    deleteCustomer: builder.mutation({
      query: (id) => ({
        url: `/customers/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Customer"],
    }),

    bulkDeleteCustomers: builder.mutation({
      query: (ids) => ({
        url: `/customers/bulk/delete`,
        method: "POST",
        body: { ids },
      }),
      invalidatesTags: ["Customer"],
    }),

    activateCustomer: builder.mutation({
      query: (id) => ({
        url: `/customers/${id}/active`,
        method: "PATCH",
        body: { isActive: true },
      }),
      invalidatesTags: (_r, _e, id) => ["Customer", { type: "Customer", id }],
    }),

    deactivateCustomer: builder.mutation({
      query: (id) => ({
        url: `/customers/${id}/active`,
        method: "PATCH",
        body: { isActive: false },
      }),
      invalidatesTags: (_r, _e, id) => ["Customer", { type: "Customer", id }],
    }),

    bulkSetActiveCustomers: builder.mutation({
      query: ({ ids, isActive }) => ({
        url: `/customers/bulk/active`,
        method: "POST",
        body: { ids, isActive },
      }),
      invalidatesTags: ["Customer"],
    }),
  }),
});

export const {
  useAddCustomerMutation,
  useGetAllCustomersQuery,
  useLazyGetAllCustomersQuery,
  useGetCustomerByIdQuery,
  useLazyGetCustomerByIdQuery,
  useUpdateCustomerMutation,
  useDeleteCustomerMutation,
  useBulkDeleteCustomersMutation,
  useActivateCustomerMutation,
  useDeactivateCustomerMutation,
  useBulkSetActiveCustomersMutation,
} = customerApi;

export default customerApi;
